/* eslint-disable import/prefer-default-export */
import { scrollToTopGradually } from 'shared-components/ScrollToTopButton/ScrollToTopButton';

export const shopAllAction = (history, selectedCategoryId, resetSearch) => {
  if (selectedCategoryId) {
    history.push(window.location.pathname);
  } else {
    resetSearch();
    scrollToTopGradually();
  }
};
